import { theme } from '@theme';
import styled from 'styled-components';

type DealTypeWrapperProps = {
  backgroundColor?: string;
};
type NoResultWrapperProps = {
  isMobileDevice?: boolean;
};

type ListWrapperProps = {
  isMobileDevice?: boolean;
};

export const Wrapper = styled.div``;

export const NoResultWrapper = styled.div<NoResultWrapperProps>`
  display: inline;
  float: left;
  padding: 5px 10px;
  background: ${theme.palette.white};
  box-sizing: border-box;
  padding: 0;
  width: ${(props) => (props.isMobileDevice ? '100vw' : '298px')};
`;

export const NoResultContainer = styled.div`
  background-color: ${theme.palette.white};
  border-bottom: 1px solid ${theme.palette.backgroundGray};
  padding: 0 10px;
  float: left;
  width: 100%;
  cursor: default;
`;

export const DealPlaceholder = styled.p`
  font-size: ${theme.typography.fontSize}px;
  line-height: 18px;
  display: inline;
  float: left;
  color: ${theme.palette.dustyTwo};
  width: 100%;
  text-align: center;
  margin: 30px 0;
`;

export const ListWrapper = styled.ul<ListWrapperProps>`
  overflow-x: hidden;
  overflow-y: auto;
  height: auto;
  max-height: ${(props) => (props.isMobileDevice ? 'none' : '364px')};
  list-style: none;
  padding: 0;
  margin: 0;
  display: block;
  outline: none;
`;

export const NotificationWrapper = styled.li`
  background-color: ${theme.palette.white};
  border-bottom: 1px solid ${theme.palette.backgroundGray};
  position: relative;
  padding: 0 10px;
  float: left;
  width: 100%;
  display: table;
  height: 100%;
  min-height: 69px;
  padding-left: 0;
  &:hover:not(.empty),
  &:focus,
  &:active,
  &.active {
    background: ${theme.palette.lightPurpleTwo};
    .bps {
      background: ${theme.palette.white};
    }
  }
  &.empty {
    cursor: default;
  }
`;

export const DealInfoWrapper = styled.div`
  width: 180px;
  padding-left: 11px;
  border-left: 0;
  display: table-cell;
  vertical-align: middle;
  float: none;
  padding-bottom: 7px;
  padding-top: 7px;
  p + p {
    padding-bottom: 5px;

    &:last-of-type {
      padding-bottom: 0;
    }
  }
`;

export const CustomerWrapper = styled.p`
  font-size: ${theme.typography.fontSize}px;
  padding-bottom: 0;
  width: 100%;
  float: left;
  color: ${theme.palette.basicGray};
  font-weight: ${theme.typography.fontWeights.semibold};
  line-height: 1.1;
  margin-bottom: 5px;
`;

export const DetailWrapper = styled.p`
  clear: both;
  width: 100%;
  color: ${theme.palette.dusty};
  font-size: ${theme.typography.h6}px;
  font-weight: ${theme.typography.fontWeights.medium};
  line-height: 1.3;
  margin-bottom: 0;
`;

export const MetaWrapper = styled.div`
  padding-top: 30px;
  width: 26px;
  float: right;
`;

export const DealTypeWrapper = styled.span<DealTypeWrapperProps>`
  background: ${theme.palette.purple};
  color: ${theme.palette.white};
  display: inline-block;
  border-radius: 50%;
  font-size: ${theme.typography.fontSize}px;
  font-weight: ${theme.typography.fontWeights.bold};
  height: 19px;
  width: 19px;
  margin: 0 auto;
  text-align: center;
  padding-top: 1px;
  line-height: 1.3;
  background-color: ${(props) => props.backgroundColor ?? props.backgroundColor};
  position: absolute;
  top: 12px;
  right: 60px;
  opacity: 0.85;
`;

export const BpsWrapper = styled.span.attrs({
  className: 'bps',
})`
  background: ${theme.palette.lightPurpleTwo};
  border-radius: 4px;
  text-align: center;
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 5px;
  min-width: 44px;
`;

export const BpsHeader = styled.em`
  font-size: ${theme.typography.fontSize}px;
  color: ${theme.palette.darkPurpleTwo};
  line-height: 16px;
  display: block;
  font-style: normal;
`;

export const BpsFooter = styled.b`
  font-size: ${theme.typography.fontSize20}px;
  color: ${theme.palette.darkPurpleThree};
  line-height: 1;
`;
